import { QueryList, TemplateRef } from '@angular/core';
export interface FormSectionModel {
    title: string;
    template: TemplateRef<any>;
    templateName: string;
    context: FromSectionContext;
  }
  
  export interface FromSectionContext {
    actionsSection: { isSaveEnable: boolean; showAlways: boolean, isStick: boolean };
    title?: string;
    description?: string;
    controls?: string[];
  }


  export class FormSectionController {
    sections: FormSectionModel[];
    templates: QueryList<TemplateRef<any>>;
    templateMap = new Map<string, TemplateRef<any>>();
    
    constructor(formSections: FormSectionModel[]) {
      this.sections = formSections;
    }
    
    
    updateSectionStatesByControls(controlNames: string[], isSaveEnable: boolean) {
      this.sections.forEach((section) => {
        section.context.actionsSection.isSaveEnable = isSaveEnable;
      });
    }

    initializeTemplates(templates: QueryList<TemplateRef<any>>) {
      this.templates = templates;
      console.log(this.templates);
      this.templates.forEach((tpl: any) => {
        const name = tpl._declarationTContainer?.localNames?.[0]; // depends on Angular version
        if (name) {
          this.templateMap.set(name, tpl);
        }
      });
  
      this.sections.forEach((section) => {
        section.template = this.templateMap.get(section.templateName);
      });
    }
  }